<mat-slider [min]="minValue()" [max]="maxValue()" [step]="step()" [disabled]="disabled()">
  <input matSliderThumb [value]="position()" (input)="onInput($event)" (blur)="touch.emit()" />
</mat-slider>
